import { Link } from "react-router-dom";

export default function AuthRequiredCard({
  title,
  subtitle,
  salonId,
  loginLabel = "Login",
  registerLabel = "Register",
  homeLabel = "Back to Portal Home",
}) {
  const hasSalon = Boolean(salonId);
  const portalBasePath = hasSalon ? `/portal/salon/${salonId}` : "/portal";
  const loginPath = hasSalon ? `${portalBasePath}/login` : "/login";
  const registerPath = hasSalon ? `${portalBasePath}/register` : "/register";

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 text-center">
      <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-2 text-sm md:text-base text-slate-600">{subtitle}</p>
      ) : null}
      <div className="mt-5 flex flex-wrap justify-center gap-3">
        <Link
          to={loginPath}
          className="rounded-full bg-slate-900 px-5 py-2 text-sm md:text-base font-semibold text-white hover:bg-slate-800"
        >
          {loginLabel}
        </Link>
        <Link
          to={registerPath}
          className="rounded-full border border-slate-300 px-5 py-2 text-sm md:text-base font-semibold text-slate-700 hover:bg-slate-50"
        >
          {registerLabel}
        </Link>
      </div>
      <div className="mt-3 flex justify-center">
        <Link
          to={portalBasePath}
          className="rounded-full border border-slate-300 px-5 py-2 text-sm md:text-base font-semibold text-slate-700 hover:bg-slate-50"
        >
          {homeLabel}
        </Link>
      </div>
    </div>
  );
}
